import { render, staticRenderFns } from "./SalaryPaidMonth.vue?vue&type=template&id=60d07d6d&scoped=true"
import script from "./SalaryPaidMonth.vue?vue&type=script&lang=js"
export * from "./SalaryPaidMonth.vue?vue&type=script&lang=js"
import style0 from "./SalaryPaidMonth.vue?vue&type=style&index=0&id=60d07d6d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d07d6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60d07d6d')) {
      api.createRecord('60d07d6d', component.options)
    } else {
      api.reload('60d07d6d', component.options)
    }
    module.hot.accept("./SalaryPaidMonth.vue?vue&type=template&id=60d07d6d&scoped=true", function () {
      api.rerender('60d07d6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalaryPaidMonth.vue"
export default component.exports